module.exports = __webpack_public_path__ + "img/BAU Seniors_20.58e0b193.jpg";